import cleanTMPUser from "../../Helpers/cleanTMPUser";

const header = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": `${process.env.REACT_APP_SERVER_URL}`,
};

export const getClientBrands = async (token: any) => {
  const requestOptions = {
    method: "GET",
    headers: {
      ...header,
      Authorization: `Bearer ${token}`,
    },
  };
  const URL = `${process.env.REACT_APP_SERVER_URL}/brand/`;
  try {
    const res = await fetch(URL, requestOptions);
    const data = await res.json();
    return data;
  } catch (err) {
    return 400;
  }
};


interface CreateClientBrandProps {
  brandData: any;
  token: any;
}

export const createClientBrand = async ({
  brandData,
  token,
}: CreateClientBrandProps) => {
  const requestOptions = {
    method: "POST",
    headers: {
      ...header,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(brandData),
  };

  const URL = `${process.env.REACT_APP_SERVER_URL}/brand/`;
  try {
    return await fetch(URL, requestOptions).then(async (res: any) => {
      return res;
    });
  } catch (err) {
    return err;
  }
};